import { render, staticRenderFns } from "./StartFinishDetailsView.vue?vue&type=template&id=63edb559&"
import script from "./StartFinishDetailsView.vue?vue&type=script&lang=js&"
export * from "./StartFinishDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports